module.exports = __webpack_public_path__ + "media/flags/gb-sct-644fc29e.svg";